import axios from 'axios';

import { updateSaikaExpectationUrl } from '../api-urls';

import config from '../../generated/config';

import { getCookie } from '../../commons/cookie';

const { brand } = config;

const b2wLoginExpectationEventRequest = email => ({
  url: updateSaikaExpectationUrl(),
  method: 'post',
  timeout: 400,
  data: {
    brand,
    action: 'LOGIN',
    session: getCookie('b2wSid') || null,
    data: {
      email
    },
    matchBy: ['email']
  }
});

export async function b2wLoginExpectationEvent(email) {
  try {
    const request = b2wLoginExpectationEventRequest(email);
    const response = await axios(request);
    return response;
  } catch (err) {
    console.error('Erro ao notificar login', err);
    return null;
  }
}

const facebookLoginExpectationEventRequest = () => ({
  url: updateSaikaExpectationUrl(),
  method: 'post',
  timeout: 400,
  data: {
    brand,
    action: 'LOGIN',
    session: getCookie('b2wSid') || null
  }
});

export async function facebookLoginExpectationEvent() {
  try {
    const request = facebookLoginExpectationEventRequest();
    const response = await axios(request);
    return response;
  } catch (err) {
    console.error('Erro ao notificar login', err);
    return null;
  }
}

const googleLoginExpectationEventRequest = () => ({
  url: updateSaikaExpectationUrl(),
  method: 'post',
  timeout: 400,
  data: {
    brand,
    action: 'LOGIN',
    session: getCookie('b2wSid') || null
  }
});

export async function googleLoginExpectationEvent() {
  try {
    const request = googleLoginExpectationEventRequest();
    const response = await axios(request);
    return response;
  } catch (err) {
    console.error('Erro ao notificar login', err);
    return null;
  }
}
